import React from "react";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import CommonForm from "../../common-form";

const EditEventForm = ({ intl,  eventToEdit,...props }) => {
  return <CommonForm eventToEdit={eventToEdit} showAdminFields {...props} />
};

EditEventForm.propTypes = {
  /**
   * Indica si el evento es de tipo deportivo
   */
  isSportEvent: PropTypes.bool,
  /**
   * Valores del formulario
   */
  values: PropTypes.object,
  /**
   * Callback que se dispara con el cambio del input
   */
  handleChange: PropTypes.func,
};

export default injectIntl(EditEventForm);
